// (05/10/2026) Người dùng (Boss legay): "bot lướt bài trong nhóm có, tìm nhóm có, nhưng chỉ lướt chứ không comment … cho nút cài đặt cho phép
// comment cả bài không liên quan". Mọi khối có bước AI chấm liên quan (chamPhuHop) nhận thêm tham số chi_bai_lien_quan:
//  · co (mặc định, anKhiRong → sơ đồ cũ không ghi khoá này): như cũ — AI chấm rồi chỉ soạn cho bài liên quan;
//  · khong: bỏ bước chấm + lọc (tu-dung.ts) → bình luận mọi bài lấy được (vẫn qua các lọc khác: bài quá ngắn, nhóm chưa tham gia, đã bình luận…).
// Tham số chỉ ảnh hưởng YAML khi = khong → kịch bản cũ giữ nguyên YAML/hash. Dịch ở Boss nên không cần plugin mới.
import type { KhoiMau, KhoiThamSo } from "./tu-dung";

export const TS_CHI_BAI_LIEN_QUAN: KhoiThamSo = {
  ten: "chi_bai_lien_quan", kieu: "chuoi", macDinh: "co", anKhiRong: true, luaChon: ["co", "khong"],
  moTa: "co = trước khi soạn, AI chấm từng bài và chỉ bình luận bài đúng chủ đề (mặc định); khong = bỏ bước chấm, bình luận cả bài không liên quan",
};

/** Gắn TS_CHI_BAI_LIEN_QUAN vào mọi khối có chamPhuHop (khối khác giữ nguyên đối tượng). */
export function themChiBaiLienQuan(ds: KhoiMau[]): KhoiMau[] {
  return ds.map((k) => (k.chamPhuHop && !k.thamSo.some((t) => t.ten === TS_CHI_BAI_LIEN_QUAN.ten) ? { ...k, thamSo: [...k.thamSo, TS_CHI_BAI_LIEN_QUAN] } : k));
}
